import axios from 'axios';
import { getAccessToken } from 'Helpers/session';
import { isEmpty, omitBy, isNil } from 'lodash';
import { PaginationType, SortingType } from 'Models/common';
import errorHandler from 'Utils/error-handler';
import normalizer from 'Utils/normalizer';

export const createQuotationRequest = async (
  data: Parameters<typeof normalizer.model.quotationRequest>[0],
) => {
  const url = `${process.env.API_URL}/${process.env.API_VER}/quotation_request/create`;
  const accessToken = getAccessToken();

  try {
    const response = await axios({
      method: 'POST',
      url: url,
      data: normalizer.model.quotationRequest(data),
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return response.data?.quotation_request;
  } catch (err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await createQuotationRequest(data);
      const callbackResponse = await errorHandler.response(error, { callback });
      if (callbackResponse?._id) return callbackResponse;

      const { value, code, message, stack } = callbackResponse;
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};

export type FetchQuotationRequestListFilters = {
  requestedBy?: string,
  sourceSite?: string,
};
export const fetchQuotationRequestList = async (
  filters: FetchQuotationRequestListFilters,
  pagination?: PaginationType,
  sorting?: SortingType,
) => {
  const url = `${process.env.API_URL}/${process.env.API_VER}/ecom/quotation_request/list`;
  const accessToken = getAccessToken();

  try {
    const response = await axios({
      method: 'POST',
      url: url,
      data: omitBy(
        {
          filters,
          pagination,
          sorting,
        },
        isNil,
      ),
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return response.data?.quotationRequests ? response.data.quotationRequests.map(normalizer.response.quotationRequest) : [];
  } catch (err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await fetchQuotationRequestList(filters, pagination, sorting);
      const callbackResponse = await errorHandler.response(error, { callback });
      if (Array.isArray(callbackResponse)) return callbackResponse;

      const { value, code, message, stack } = callbackResponse;
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};
